module.exports = __webpack_public_path__ + "img/ergonomic-image.8ea96246.png";